import { AvailableModules } from 'generated/featureDefinitions'

import { ModuleAvailabilityType } from 'modules/core/hooks/useModuleAvailability'

export const isModuleAvailabilityEnabled = (
  moduleAvailabilities: ModuleAvailabilityType[],
  module: AvailableModules
) => {
  return (
    moduleAvailabilities.find((moduleAvailability) => moduleAvailability.id === module)
      ?.available ?? false
  )
}
